<template>
  <div style="width:220px;" class="mt-8">
    <v-row class="px-2 ">
      <v-col cols="12" md="12"
        ><h3 class="redtext">
          Bei ausgewählten <span style="font-size:32px">Partnern</span>
        </h3>
        Den Clearment Vertragsschutz erhalten Sie bei ausgewählten
        <b class="redtext">kostenlos</b>.
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="12">
        <img
          v-for="vm in vms"
          :key="vm.user_id"
          :src="vm.show_user_bild"
          style="width: 60px"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: "menue-out",
    props: ["vms"],
    computed: {},
  };
</script>
